import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import EventPageHeader from "./EventPageHeader";
import CalendarEvent from "../../../Models/CalendarEvent";
import EventPageBody from "./EventPageBody";
import EventPageFooter from "./EventPageFooter";
import openWebPage from "../../../Helper/openWebPage";
import {TransitionProps} from "@material-ui/core/transitions";
import {Slide} from "@material-ui/core";

interface EventPageViewControllerProps {
    open: boolean;
    calendarEvent: CalendarEvent;
    onDismiss: () => void;
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const EventPageViewController = (props: EventPageViewControllerProps) => {
    const {
        open,
        calendarEvent,
        onDismiss,
    } = props;

    const onClickAdd = () => {
        openWebPage(calendarEvent.addURL);
    };

    return(
        <Dialog
            fullScreen
            TransitionComponent={Transition}
            open={open}>
            <EventPageHeader title={calendarEvent?.title || ""} />
            <EventPageBody calendarEvent={calendarEvent} />
            <EventPageFooter onClose={onDismiss} onAdd={onClickAdd} id={calendarEvent?.id || ""} />
        </Dialog>
    );
};

export default EventPageViewController;